/* jshint newcap: false */
define(
    'views/logo-view',[
        'jquery',
        'utils/view',
        'utils/translate',
        'utils/toast',

        'handlebars'
    ],
    function ($, View, t, toast, Handlebars) {
        'use strict';

        var LogoView = (function () {

            function LogoView() {
                this.lb = $('[data-view="LogoBuilder"]');
                this.ll = $('[data-view="LogoListing"]');
                this.ml = $('#main-listing');
                this.fc = $('#folder-container');
                this.feFirstDiv = $('#folder-container-root');
                //this.tfc = $('#popup-folder-container-template');
            }


            LogoView.prototype.LogoBuilderInit = function () {
                this.LogoBuilderBindings();
            };

            LogoView.prototype.LogoBuilderBindings = function () {
                if ( !this.lb.length ) {
                    return;
                }

                var _this = this;

                // Todo - check previous commit with Johannes
                this.lb.on('showSaveError', function(e, data) {
                    if (data)
                        toast.queueError(t(data));
                    else
                        toast.queueError(t('An error occured, please try again later.'));
                    //ab.show();
                }).on('ready', function(e) {
                    _this.lb.parent().addClass('ready');
                });
            };


            LogoView.prototype.LogoListingBindings = function () {
                if ( !this.ll.length ) {
                    return;
                }

                this.LogoListingBindAdd();
            };

            LogoView.prototype.LogoListingBindAdd = function () {
                var _this = this;
                
                this.ll.on('add', function (e, data) {
                    if (data.isFolder) {
                        if (!_this.llFolderTemplate) {
                            _this.llFolderTemplate = Handlebars.compile($('#folder-listing-entry').html());
                        }

                        if (!_this.llFolderContainerTemplate) {
                            _this.llFolderContainerTemplate = Handlebars.compile($('#folder-container-entry').html());
                        }

                        var htmlFolder = $($.parseHTML(_this.llFolderTemplate(data).replace(/^\s+|\s+$/gm, '')));
                        htmlFolder.fadeTo(0);
                        _this.feFirstDiv.after(htmlFolder);
                        htmlFolder.fadeTo(500, 1);
                        //$($.parseHTML(_this.llFolderTemplate(data).replace(/^\s+|\s+$/gm, ''))).fadeTo(0).prependTo(_this.ml).fadeTo(500, 1);
                        $($.parseHTML(_this.llFolderContainerTemplate(data).replace(/^\s+|\s+$/gm, ''))).prependTo(_this.fc);
                        var popup = $('#popup-folder-container');
                        if (popup) {
                            popup.trigger('add', data);
                        }

                    } else {
                        if (!_this.llEntryTemplate) {
                            _this.llEntryTemplate = Handlebars.compile($('#logo-listing-entry').html());
                        }

                        if (data.folderID === '') {
                            $($.parseHTML(_this.llEntryTemplate(data).replace(/^\s+|\s+$/gm, ''))).fadeTo(0).prependTo(_this.ml).fadeTo(400, 1, function () {
                                $(this).removeAttr('style');
                            });
                        } else {
                            var folder = $('#folder-' + data.folderID);
                            $('#logo-listing-container').trigger('openFolder', data.folderID);
                            $($.parseHTML(_this.llEntryTemplate(data).replace(/^\s+|\s+$/gm, ''))).fadeTo(0).prependTo(folder.children('.image-container')).fadeTo(400, 1, function () {
                                $(this).removeAttr('style');
                            });
                        }
                    }
                });
            };

            LogoView.prototype.FolderPopupBindAdd = function () {
                var _this = this;
                $('body').on('add', '#popup-folder-container', function (e, data) {
                    var popupContainer = $('#popup-folder-container');

                    if (popupContainer) {
                        if (!_this.plFolderTemplate) {
                            _this.plFolderTemplate = Handlebars.compile($('#popup-folder-entry-templates').html());
                        }

                        $($.parseHTML(_this.plFolderTemplate(data).replace(/^\s+|\s+$/gm, ''))).fadeTo(0).prependTo(popupContainer).fadeTo(500, 1);
                    }
                });
            };

            LogoView.prototype.ShowInitialFolder = function() {
                var initialFolder = this.ml.data('initial-folder');
                if (initialFolder) {
                    $('#logo-listing-container').trigger('openFolder', initialFolder);
                }
            };

            LogoView.prototype.LogoBindActionDownloadAll = function() {
                if ( !$('a[data-action="download-all-logos"]').length ) {
                    return;
                }

                var _this = this;

                 $('body').on('click', 'a[data-action="download-all-logos"]', function(e) {
                    e.preventDefault();
                     $.ajax({
                        url: '/data/download-logo.json',
                        success: function(data) {
                            if (!data || !data.source) {
                                toast.queueError(t('An error occured, please try again later.'));
                            } else {
                                $("<iframe/>").attr({
                                    src: data.source,
                                    style: "visibility:hidden;display:none"
                                }).appendTo('body');    
                            }
                        },
                        error: function() {
                            toast.queueError(t('An error occured, please try again later.'));
                        }
                    });
                 });
            };

            return LogoView;
        })();

        return View('LogoListing', function () {
            var v = new LogoView();

            v.LogoBuilderInit();
            v.LogoListingBindings();
            v.LogoBindActionDownloadAll();
            v.FolderPopupBindAdd();
            v.ShowInitialFolder();
        });
    }
);

